import { useEffect } from "react";
import { useSetRecoilState } from "recoil";
import { snackbarAtom } from "../selectorsAtoms";

type Parameters = {
  mutation: {
    isSuccess: boolean;
    isError: boolean;
    reset: Function;
    error?: any;
  };
  successMessage: string;
  errorMessage: string;
};

const useEffectSuccessAndErrorSnackbar = ({
  mutation,
  successMessage,
  errorMessage,
}: Parameters) => {
  const setSnackbar = useSetRecoilState(snackbarAtom);

  useEffect(() => {
    if (mutation.isError || mutation.isSuccess) {
      const message = mutation.isSuccess
        ? successMessage
        : mutation.error?.response?.data?.error?.message || errorMessage;
      setSnackbar([{
        open: true,
        type: mutation.isSuccess ? "success" : "error",
        message,
      }]);
      mutation.reset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mutation.isError, mutation.isSuccess]);
};

export default useEffectSuccessAndErrorSnackbar;
